import { createContext, useContext } from 'react';
import { baseImpressionOption } from '../../../../pages/DiffRetainer/utils';

export const DiffRetainerLangContext = createContext({
    getDiffRetainerLang: () => undefined,
    impressionOption: baseImpressionOption,
});

const useDiffRetainerLangContext = () => {
    const context = useContext(DiffRetainerLangContext);
    if (!context) {
        throw new Error('context must be used within a Context Provider');
    }
    return context;
};

export default useDiffRetainerLangContext;
